module.exports = __webpack_public_path__ + "img/Picture5.b94f9618.png";